<ng-container *ngIf="mode == 'DEFAULT'">
    <div class="mt-1 overflow-hidden flex-w-full px-2 py-1 field-container" [hidden]="!fieldConfig.visible "
        *ngIf="fieldConfig.fieldControlType != 'BUTTON'"
        [class.disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly  || (baseData['_editable'] != null && !baseData['_editable'] )|| (fieldConfig?.columnCode == '_id' && !isNew)">
        <div class="items-center justify-between ng-star-inserted">
            <div>
                <div class="font-medium flex items-start justify-between" [title]="fieldConfig.fieldDescription">
                    <div>
                        <span class="text-red-500"
                            [hidden]="!fieldConfig.fieldRequired && !fieldConfig.required">*</span>
                        <span class="text-black drk-field-title">{{fieldConfig.header | transloco}}</span>
                        <span *ngIf="fieldConfig.isValid === false" class="text-red-600 text-sm invalid-value">
                            <!-- &#9888;&#65039; --> {{'common.invalidValue' | transloco}}
                        </span>
                        <span class="text-zinc-200 font-small" [hidden]="true">| {{fieldConfig.columnCode}}</span>
                    </div>
                    <div>
                        <mat-icon [svgIcon]="'heroicons_solid:question-mark-circle'"
                            [title]="fieldConfig?.notes | transloco" *ngIf="fieldConfig?.notes"></mat-icon>
                    </div>
                </div>

                <!--div [ngSwitch]="fieldConfig.fieldControlType">
                <div class="ml-1 mt-2 flex-w-full sm:mt-1" *ngSwitchCase="'DROPDOWNLIST'">
                  <select [(ngModel)]="baseData[fieldConfig.columnCode]"
                          [disabled]="readonly"
                          (ngModelChange)="onChange()">
                    <option value=""></option>
                    <option *ngFor="let option of options" [value]="option.value">
                      {{option.text}}
                    </option>
                  </select>
                </div>-->
                <!-- Aggiungi qui altri casi per gli altri tipi di campo se necessario -->
                <!--</div>-->

                <ng-container *ngIf="!readonly; else readonlyField">

                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1"
                        *ngIf="fieldConfig.fieldControlFormat === 'PSW'">
                        <kendo-textbox type="password" [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly  || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()" class="k-textbox" />
                    </div>

                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1 flex items-center"
                        *ngIf="fieldConfig.fieldControlFormat === 'EML'">
                        <kendo-textbox type="email" [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()" class="k-textbox flex-grow" />
                        <a [href]="'mailto:' + baseData[fieldConfig?.columnCode]"
                            *ngIf="baseData[fieldConfig?.columnCode]">
                            <mat-icon class="ml-2">email</mat-icon>
                        </a>
                    </div>

                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1 flex items-center"
                        *ngIf="fieldConfig.fieldControlFormat === 'LNK'">
                        <kendo-textbox type="email" [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()" class="k-textbox flex-grow" />
                        <a [href]="baseData[fieldConfig?.columnCode]" target="_blank"
                            *ngIf="baseData[fieldConfig?.columnCode]">
                            <mat-icon class="ml-2">link</mat-icon>
                        </a>
                    </div>

                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1 flex items-center"
                        *ngIf="fieldConfig.fieldControlFormat === 'PHN'">
                        <kendo-textbox type="phone" [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly"
                            (change)="onChange()" class="k-textbox flex-grow" />
                        <a [href]="'callto:' + baseData[fieldConfig?.columnCode]"
                            *ngIf="baseData[fieldConfig?.columnCode]">
                            <mat-icon class="ml-2">call</mat-icon>
                        </a>
                    </div>

                    <!-- Textbox Field -->
                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1"
                        *ngIf="fieldConfig.fieldDbType === 'STRING' && fieldConfig.fieldControlType === 'TEXTBOX' && fieldConfig.fieldControlFormat !== 'PSW' && fieldConfig.fieldControlFormat !== 'EML' && fieldConfig.fieldControlFormat !== 'PHN' && fieldConfig.fieldControlFormat !== 'LNK'">
                        <kendo-textbox
                            [disabled]="readonly|| fieldConfig.fieldReadonly  || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )|| (fieldConfig?.columnCode == '_id' && !isNew)"
                            [(ngModel)]="baseData[fieldConfig?.columnCode]" (change)="onChange()"></kendo-textbox>
                    </div>

                    <div #fieldTextarea class="ml-1 mt-2 flex-w-full sm:mt-1"
                        *ngIf="fieldConfig.fieldDbType == 'STRING' && fieldConfig.fieldControlType == 'TEXTAREA'">
                        <kendo-textarea [rows]="fieldConfig.format? fieldConfig.format : 3"
                            [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [disabled]="readonly|| fieldConfig.fieldReadonly  || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()"></kendo-textarea>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'INT' && fieldConfig.fieldControlType == 'TEXTBOX'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-numerictextbox [step]="1" [(ngModel)]="baseData[fieldConfig?.columnCode]" format="##"
                            [disabled]="readonly|| fieldConfig.fieldReadonly  || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()"></kendo-numerictextbox>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'DECIMAL' && fieldConfig.fieldControlType == 'TEXTBOX'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-numerictextbox [step]="0.1" [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            format="##.##"
                            [disabled]="readonly|| fieldConfig.fieldReadonly  || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()"></kendo-numerictextbox>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'DATETIME' && fieldConfig.fieldControlType == 'DATEPICKER'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-datepicker [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [format]="fieldConfig.fieldControlFormat" [placeholder]="fieldConfig.fieldControlFormat"
                            [disabled]="readonly|| fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (valueChange)="onChange()"></kendo-datepicker>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'DATETIME' && fieldConfig.fieldControlType == 'DATETIMEPICKER'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-datetimepicker [(ngModel)]="baseData[fieldConfig?.columnCode]"
                            [format]="fieldConfig.fieldControlFormat" [placeholder]="fieldConfig.fieldControlFormat"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (valueChange)="onChange()"></kendo-datetimepicker>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'BOOL' && fieldConfig.fieldControlType == 'CHECKBOX'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-switch [(ngModel)]="baseData[fieldConfig.columnCode]" (valueChange)="onChange()"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'])">
                        </kendo-switch>
                    </div>

                    <div *ngIf="fieldConfig.fieldControlType == 'DROPDOWNLIST'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-combobox #combo1 [data]="options" textField="text" valueField="value"
                            [valuePrimitive]="true" [filterable]="true" (filterChange)="handleFilter($event)"
                            [virtual]="virtual" [(ngModel)]="baseData[fieldConfig.columnCode]"
                            [disabled]="readonly|| fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (valueChange)="onChange()"></kendo-combobox>
                    </div>

                    <div *ngIf="fieldConfig.fieldControlType == 'RADIO'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <div *ngFor="let o of options" class="p-2">
                            <input type="radio" kendoRadioButton [(ngModel)]="baseData[fieldConfig.columnCode]"
                                [value]="o.value" [id]="'rbt_' + fieldConfig.columnCode + '_' + o.value" [name]="fieldConfig.columnCode"
                                [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'])"
                                (change)="onChange()" />

                            <label class="k-radio-label" [for]="'rbt_' + fieldConfig.columnCode + '_' + o.value">
                                {{ o.text }}
                            </label>
                        </div>

                    </div>

                    <div *ngIf="fieldConfig.fieldControlType == 'COLORPICKER'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-colorpicker [valuePrimitive]="true" [(ngModel)]="baseData[fieldConfig.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] ) "
                            (change)="onChange()">
                        </kendo-colorpicker>
                    </div>

                    <!-- CAPTCHA Field -->
                    <div #captchaContainer class="ml-1 mt-2 flex-w-full sm:mt-1"
                        *ngIf="fieldConfig.fieldControlType == 'CAPTCHA'">
                        <re-captcha #captchaRef (resolved)="onCaptchaResolved($event, fieldConfig.columnCode)"
                            siteKey="6Lfo6jsqAAAAANIdkYydyPqCEjqWI2qqtx1PpZXx">
                        </re-captcha>
                    </div>

                    <!-- Map Field -->
                    <div #fieldMap class="ml-1 mt-2 flex-w-full sm:mt-1" *ngIf="fieldConfig.fieldDbType === 'LOCATION'">
                        <!-- Map Search Bar -->
                        <div class="ml-1 mt-2 flex-w-full sm:mt-1">
                            <kendo-autocomplete [(ngModel)]="searchQuery" [data]="searchResults"
                                [valueField]="'formatted_address'" (input)="onSearch($event.target.value)"
                                (valueChange)="onSearchSelect($event)">
                            </kendo-autocomplete>
                        </div>
                        <br>
                        <kendo-map [center]="locationCenter" [zoom]="15" (mapClick)="onMapClick($event)">
                            <kendo-map-layers>
                                <kendo-map-tile-layer [subdomains]="tileSubdomains" [urlTemplate]="tileUrl">
                                </kendo-map-tile-layer>
                                <kendo-map-marker-layer [data]="markers" locationField="location" titleField="name">
                                    <ng-template kendoMapMarkerTemplate let-dataItem>
                                        <kendo-map-marker [location]="dataItem.location">
                                        </kendo-map-marker>
                                    </ng-template>
                                </kendo-map-marker-layer>
                            </kendo-map-layers>
                        </kendo-map>
                    </div>



                    <div *ngIf="fieldConfig.fieldControlType == 'HTML'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-editor style="height: 200px;" [valuePrimitive]="true"
                            [(ngModel)]="baseData[fieldConfig.columnCode]"
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (change)="onChange()">
                        </kendo-editor>
                    </div>

                    <div *ngIf="fieldConfig.fieldControlType === 'CODEEDITOR'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="editorContent"
                            (onInit)="onMonacoInit($event)">
                        </ngx-monaco-editor>
                    </div>


                    <div *ngIf="fieldConfig.fieldControlType === 'RATING'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-rating precision="half" (ngModelChange)="onChange($event)"
                            [(ngModel)]="baseData[this.fieldConfig.columnCode]">
                        </kendo-rating>
                    </div>


                    <div *ngIf="fieldConfig.fieldControlType === 'LISTBOX'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <div class="new-item-input ml-1 mt-2 flex-w-full sm:mt-1 flex items-center">
                            <kendo-textbox [(ngModel)]="newItem" placeholder="Enter new item"></kendo-textbox>
                            <button (click)="addNewItem()" class="ml-4 mr-2">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                        <br>
                        <kendo-listbox style="width: 100%;" kendoListBoxDataBinding [data]="arrayData"
                            textField="content" valueField="index" [(ngModel)]="selectedItems"
                            (ngModelChange)="onSelectionChange($event)" (remove)="removeSelectedItems()"
                            [toolbar]="toolbarSettings">
                        </kendo-listbox>
                    </div>

                    <div *ngIf="fieldConfig.fieldControlType === 'DRPLISTBOX'" class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <div class="new-item-input ml-1 mt-2 flex-w-full sm:mt-1 flex items-center">
                            <kendo-combobox #combo2 [data]="options" textField="text" valueField="value"
                                [valuePrimitive]="true" [(ngModel)]="newItem" [virtual]="virtual"
                                [disabled]=" readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                                (valueChange)="onChange()">
                            </kendo-combobox>
                            <button (click)="addNewItem()" class="ml-4 mr-2">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                        <br>
                        <kendo-listbox style="width: 100%;" kendoListBoxDataBinding [data]="arrayData"
                            textField="content" valueField="index" [(ngModel)]="selectedItems"
                            (ngModelChange)="onSelectionChange($event)" (remove)="removeSelectedItems()"
                            [toolbar]="toolbarSettings">
                        </kendo-listbox>
                    </div>



                    <div *ngIf="fieldConfig.fieldDbType == 'DECIMAL' && fieldConfig.fieldControlType == 'SLIDER'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-slider style="width:100%" [tickPlacement]="'both'"
                            [(ngModel)]="baseData[this.fieldConfig.columnCode]" (ngModelChange)="onChange($event)"
                            [largeStep]="sliderOptions.largeStep || 5" [smallStep]="sliderOptions.smallStep || 1"
                            [dragHandleTitle]="baseData[this.fieldConfig.columnCode]" [showButtons]="false"
                            [min]="sliderOptions.min || 0" [max]="sliderOptions.max || 100">
                        </kendo-slider>
                    </div>

                    <div *ngIf="fieldConfig.fieldDbType == 'STRING' && fieldConfig.fieldControlType == 'MASKED'"
                        class="ml-1 mt-2 flex-w-full sm:mt-1">
                        <kendo-maskedtextbox [mask]="mask" [(ngModel)]="maskedtext" (ngModelChange)="onChange($event)">
                        </kendo-maskedtextbox>
                    </div>

                    <div *ngIf="fieldConfig.fieldControlType == 'MATRIX'">
                        <app-drake-matrix [viewCode]="fieldConfig.fieldControlFormat"
                            [readonly]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            [matrixData]="baseData[fieldConfig?.columnCode]"
                            (valueChanged)="onMatrixDataChanged($event)" [fieldConfig]="fieldConfig"></app-drake-matrix>
                    </div>

                    <!-- Upload Icon -->
                    <div *ngIf="fieldConfig.fieldDbType == 'FILE' && (fieldConfig.fieldControlType == 'FILEUPLOAD' || fieldConfig.fieldControlType == 'IMAGEUPLOAD')"
                        class="ml-1 mt-2 flex-w-full sm:mt-1" class="upload-field">

                        <div *ngIf="baseData[fieldConfig?.columnCode] && baseData[fieldConfig?.columnCode]?.id"
                            [class]="fieldConfig?.format">
                            <app-drake-file-preview [fileId]="baseData[fieldConfig?.columnCode]?.id"
                                [heightMode]="fieldConfig.format"></app-drake-file-preview>
                        </div>
                        <div *ngIf="!baseData[fieldConfig?.columnCode] || !baseData[fieldConfig?.columnCode]?.id"
                            class="no-file text-center border-2 border-solid border-gray-300 bg-gray-100">
                            <div class="p-8">
                                {{"common.noFile" | transloco}}
                            </div>
                        </div>
                        <div class="flex mt-2">
                            <kendo-textbox [disabled]="true" [ngModel]="baseData[fieldConfig?.columnCode]?.fileName"
                                class="ml-1 mt-2 flex-w-full sm:mt-1"
                                [title]="baseData[fieldConfig?.columnCode]?.fileName"></kendo-textbox>
                            <button
                                [hidden]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                                (click)="openFileManager()" class="upload-button ml-2">
                                <mat-icon>cloud_upload</mat-icon>
                            </button>
                            <button
                                [hidden]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                                (click)="removeFile()" class="upload-button ml-2"
                                *ngIf="baseData[fieldConfig?.columnCode]">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-template #readonlyField>
                    <div #fieldTextbox class="ml-1 mt-2 flex-w-full sm:mt-1"
                        *ngIf="(fieldConfig.fieldControlType !== 'DROPDOWNLIST') 
                    &&  fieldConfig.fieldDbType != 'FILE' 
                    && (fieldConfig.fieldControlType != 'FILEUPLOAD' && fieldConfig.fieldControlType != 'IMAGEUPLOAD')">

                        <kendo-textbox
                            [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            [(ngModel)]="baseData[fieldConfig?.columnCode]" (change)="onChange()"></kendo-textbox>
                    </div>


                    <div *ngIf="fieldConfig.fieldDbType == 'FILE' && (fieldConfig.fieldControlType == 'FILEUPLOAD' || fieldConfig.fieldControlType == 'IMAGEUPLOAD')"
                        class="upload-field">

                        <div *ngIf="baseData[fieldConfig?.columnCode]" style="height:100%">
                            <app-drake-file-preview [fileId]="baseData[fieldConfig?.columnCode]?.id"
                                [heightMode]="fieldConfig.format"></app-drake-file-preview>
                        </div>
                        <div *ngIf="!baseData[fieldConfig?.columnCode]">
                            {{"common.noFile" | transloco}}
                        </div>
                        <div class="flex mt-2">
                            <kendo-textbox [disabled]="true" [ngModel]="baseData[fieldConfig?.columnCode]?.fileName"
                                [title]="baseData[fieldConfig?.columnCode]?.fileName"></kendo-textbox>
                        </div>
                    </div>
                    <div *ngIf="fieldConfig.fieldControlType == 'DROPDOWNLIST'">
                        <kendo-combobox #combo3 [data]="options" textField="text" valueField="value"
                            [valuePrimitive]="true" [filterable]="true" (filterChange)="handleFilter($event)"
                            [virtual]="virtual" [(ngModel)]="baseData[fieldConfig.columnCode]"
                            [disabled]=" readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData['_editable'] != null && !baseData['_editable'] )"
                            (valueChange)="onChange()">
                        </kendo-combobox>
                    </div>

                </ng-template>
            </div>
        </div>
    </div>

    <div class="mt-1 overflow-hidden px-2 py-1 field-container"
        *ngIf="fieldConfig.fieldControlType === 'BUTTON' && fieldConfig.visible">

        <div class="w-full flex items-center justify-end">
            <button kendoButton class="ml-auto flex items-center" [title]="fieldConfig.fieldDescription"
                [disabled]="readonly || fieldConfig.fieldReadonly || fieldConfig.readonly || (baseData?._editable !== null && baseData?._editable === false)"
                (click)="onFieldButtonClick(fieldConfig)">

                <mat-icon *ngIf="fieldConfig.fieldControlFormat" style="justify-content: flex-start !important">{{
                    fieldConfig.fieldControlFormat }}</mat-icon>

                {{ (fieldConfig.header) | transloco }}
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="mode == 'KPI'">
    <div class="mt-1 overflow-hidden flex w-full px-2 py-1 field-container" [hidden]="!fieldConfig.visible"
        *ngIf="fieldConfig.fieldControlType != 'BUTTON'">
        <div class="items-center justify-center text-center flex flex-col flex-1 ng-star-inserted">
            <div>
                <div class="font-medium text-medium flex items-center justify-center"
                    [title]="fieldConfig.fieldDescription">
                    <div>
                        <span class="text-red-500"
                            [hidden]="!fieldConfig.fieldRequired && !fieldConfig.required">*</span>
                        {{fieldConfig.header | transloco}}
                    </div>
                    <div>
                        <mat-icon [svgIcon]="'heroicons_solid:question-mark-circle'"
                            [title]="fieldConfig?.notes | transloco" *ngIf="fieldConfig?.notes">
                        </mat-icon>
                    </div>
                </div>

                <div class="font-bold text-4xl kpi-value text-center">
                    {{baseData[fieldConfig?.columnCode]}}
                </div>
            </div>
        </div>
    </div>
</ng-container>